import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import NotFound from "./Error/notFound";
import Navbar from "./Navbar/Navbar";
import Footer from "./Footer/Footer";

// Services
import SolarPanel from "./pages/services/SolarPanel";
import SolarInverter from "./pages/services/SolarInverter";
import EnergyStorageSystems from "./pages/services/EnergyStorageSystems";
import SolarEVehicle from "./pages/services/SolarEVehicle";
import SolarEPCServices from "./pages/services/SolarEPCServices";

import "./styles/tailwind.css";
import ScrollToTop from "./ScrollToTop.js";

// AppContent handles routes + footer logic
const AppContent = () => {
  const location = useLocation();

  // Footer should not appear on these paths
  const hideFooterPaths = ["/contact"];

  return (
    <>
      <Navbar />
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />

        {/* Services Routes */}
        <Route path="/services/solar-panel" element={<SolarPanel />} />
        <Route path="/services/solar-inverter" element={<SolarInverter />} />
        <Route path="/services/energy-storage-systems" element={<EnergyStorageSystems />} />
        <Route path="/services/solar-e-vehicle" element={<SolarEVehicle />} />
        <Route path="/services/solar-epc-services" element={<SolarEPCServices />} />

        {/* Fallback */}
        <Route path="*" element={<NotFound />} />
      </Routes>

      {/* Show footer only if current path is NOT in hideFooterPaths */}
      {!hideFooterPaths.includes(location.pathname) && <Footer />}
    </>
  );
};

const App = () => (
  <Router>
    <AppContent />
  </Router>
);

export default App;
